import { FieldModel, ResourceConcernComponents } from '@cibo/core'
import { useEqipRecommendations } from '@cibo/landmanager'
import { ListCell } from '@cibo/ui'
import { GridCellParams } from '@mui/x-data-grid-pro'

export const ResourceConcernsCell = ({ row: { resourceId } }: GridCellParams<any, FieldModel>) => {
  const recommendations = useEqipRecommendations(resourceId)

  const concernRecommendations =
    recommendations.data?.resourceConcernComponents?.filter(
      ({ vulnerability }) => !!vulnerability
    ) || []

  return (
    <ListCell<ResourceConcernComponents>
      isLoading={recommendations.isLoading}
      listItems={concernRecommendations}
      accessor={(practice: ResourceConcernComponents) => practice.resourceConcernDesc}
    />
  )
}
